import React, { useRef, useEffect, useState } from "react";
import videojs from "video.js";
import "../../assets/videojs-plus/plugins/live/index";
import "../../assets/videojs-plus/plugins/eme/index";
import "../../assets/videojs-plus/plugins/live/style.css";
import {
  BASE_URL,
  Client,
  getAccessToken,
  getRandomId,
} from "../../services/api-client";
//@ts-ignore
import * as crypto from "crypto-js";
import {
  CookieKeys,
  cookieSplitter,
  setJSONValue,
} from "../../services/cookie-service";
import { querySplitter } from "../../services/utils";

const defaultPlayerOptions = {
  autoplay: true,
  muted: true,
  liveui: false,
  withCredentials: true,
  fluid: true,
  fill: false,
  aspectRatio: "16:9",
  mobileView: false,
};
const b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

const distributionChecked: any = {
  "d374xcw4g3077d.cloudfront.net": "d11ojfpvx48blf.cloudfront.net",
  "d3gn7ri9n5ex0y.cloudfront.net": "d3j2dil5nt5ey2.cloudfront.net",
  "d35ru2gyr31pud.cloudfront.net": "d3rg2v5h3lrwe3.cloudfront.net",
  "d1cuayhffpr3uw.cloudfront.net": "d3oyxwh78yghyt.cloudfront.net",
  "d179dsz8d2ru5f.cloudfront.net": "d2ecyzu3pcb97n.cloudfront.net",
  "d2obpqg55vwqr0.cloudfront.net": "d3ii5cd02v2q1j.cloudfront.net",
  "d3hr33m2k0rnsm.cloudfront.net": "d1c3ly0impyzvn.cloudfront.net",
  "d158klmbw8216q.cloudfront.net": "d2zzioovffkj90.cloudfront.net",
  "d2yfdi0ppzcedz.cloudfront.net": "d3shkp9olayk5b.cloudfront.net",
  "d24tuhadu3hwiq.cloudfront.net": "d65fadaol0v45.cloudfront.net",
  "df6w31i1pjdog.cloudfront.net": "d2t2de0orl3s08.cloudfront.net",
  "d21asfdntm4t8.cloudfront.net": "d3sjduoaqq7j2c.cloudfront.net",
  "d1oo1be3pw1qi7.cloudfront.net": "d1g0j9b2n89ac5.cloudfront.net",
  "d2ubi13cyz6h1i.cloudfront.net": "d1hqzibh1ul904.cloudfront.net",
  "d2e0ogc0gakb3z.cloudfront.net": "d2vtnnw5kaz1i7.cloudfront.net",
  "d97w3e1roxd23.cloudfront.net": "daneg6xjuquct.cloudfront.net",
  "d1witph54c5irt.cloudfront.net": "dfjy6hucude0k.cloudfront.net",
  "d2pnmjeiyr8lb4.cloudfront.net": "d19lcagidd1dnk.cloudfront.net",
  "d2ab269mj1se7q.cloudfront.net": "d29utchohh8vx2.cloudfront.net",
  "d2ddk9qypl2psb.cloudfront.net": "d29pilizbngc3n.cloudfront.net",
  "d3ewklxz073ox4.cloudfront.net": "d3eelrsydan9rz.cloudfront.net",
  "d32vvailaerf4c.cloudfront.net": "d91p6lxk6j7ey.cloudfront.net",
  "drq2e9l6snap2.cloudfront.net": "d3cellzsrhjepz.cloudfront.net",
  "d1k30fvokeewna.cloudfront.net": "dkxudmn1v0ggg.cloudfront.net",
  "d3nedj6mq0f69r.cloudfront.net": "d395fwihx2hrcp.cloudfront.net",
  "d3qpgsml2jaxr9.cloudfront.net": "dmg9p9obscrvc.cloudfront.net",
  "d2vu6fujym16f7.cloudfront.net": "dv7qmnu4akjpz.cloudfront.net",
  "dysifjesp9r76.cloudfront.net": "d25i8gzv5anu0u.cloudfront.net",
  "d2h70sp4htz0aq.cloudfront.net": "dbiuzgdg70su2.cloudfront.net",
  "d38jsmglzfjnpo.cloudfront.net": "d2wvvu66cruyvm.cloudfront.net",
  "d15x7t715dv3fg.cloudfront.net": "dyhnr0tapjaos.cloudfront.net",
  "d1hnbe3xiyvzqw.cloudfront.net": "d2237d8kxh8heq.cloudfront.net",
  "dyrcutegmere3.cloudfront.net": "dzztvikjx8r71.cloudfront.net",
  "dk9ks3u37am9y.cloudfront.net": "djlzuoy73fcfa.cloudfront.net",
  "d1wey3ibl098n2.cloudfront.net": "d15qu28mu4q4jw.cloudfront.net",
  "d2u0gg12pul966.cloudfront.net": "d2nzpytossbnr7.cloudfront.net",
  "d1zz679u8evm9q.cloudfront.net": "d2biaple7zet0x.cloudfront.net",
  "d19vci6kq4jww6.cloudfront.net": "d2xsgh02l6xs17.cloudfront.net",
  "d1p41voxflp9rv.cloudfront.net": "d2zbr2awejh2rr.cloudfront.net",
  "dct1nr0l2e20v.cloudfront.net": "d9zdgf3fvik0j.cloudfront.net",
  "ddxp4n5i5qrl7.cloudfront.net": "d2telwqzf19m93.cloudfront.net",
  "d1w9d8sob2154l.cloudfront.net": "d2lc7vq1si1j5y.cloudfront.net",
  "d3rlu0w4vhls6w.cloudfront.net": "d3a32exd24pf8u.cloudfront.net",
  "d2wtihhqocy3tb.cloudfront.net": "d34v6dqkfcygve.cloudfront.net",
  "ddbacdlvl6v94.cloudfront.net": "d3c1q3ru83c4h5.cloudfront.net",
  "d3qbbq6h3vax2u.cloudfront.net": "dccswm5aa2kat.cloudfront.net",
  "d2c1c7lszqum4v.cloudfront.net": "d2gx8oc3c51ncb.cloudfront.net",
  "d3p9hxh2evoynn.cloudfront.net": "d3ddsirpix4hzf.cloudfront.net",
  "dea2vtj6g6xpi.cloudfront.net": "d32dzrd6ufwtpi.cloudfront.net",
  "d34wwu4rutenws.cloudfront.net": "d2uuxfg05b54lt.cloudfront.net",
  "d39up8z5e4vnvo.cloudfront.net": "d1dddredloedat.cloudfront.net",
  "d3mfqu9lk67hc7.cloudfront.net": "dzt1mrxkbk3n4.cloudfront.net",
  "d39irtfyfjplh0.cloudfront.net": "d38rzpil7rjv9c.cloudfront.net",
  "d2k3rp9zp5y3e0.cloudfront.net": "d21jl4gb1zyj6x.cloudfront.net",
  "d1144ttsp5f8z4.cloudfront.net": "dx57obye0vt47.cloudfront.net",
  "d1ffuzy0gf654o.cloudfront.net": "doms66qrvng89.cloudfront.net",
  "d3o1eiprt0nhqx.cloudfront.net": "dmhm2c0dcfxaf.cloudfront.net",
  "d2quftkth8y4h4.cloudfront.net": "d374zsxt7j0zga.cloudfront.net",
  "d39c9fz74uqog2.cloudfront.net": "d8b6b9914nh8k.cloudfront.net",
  "d15xjjiyf4dcw6.cloudfront.net": "d2jl6y7utpjdwb.cloudfront.net",
  "d1s7xexycexkn8.cloudfront.net": "d16i66eawb4s5o.cloudfront.net",
  "d22ir4a7fzo6bg.cloudfront.net": "d3rgrqkrtzrhkv.cloudfront.net",
  "d1tziokzqpo8o.cloudfront.net": "d3sye223tqe40g.cloudfront.net",
  "d9r9zvcavxoel.cloudfront.net": "d1u2sl1texm59a.cloudfront.net",
  "d5k3h2imfd24u.cloudfront.net": "d4m18hzofenvw.cloudfront.net",
  "d2g5ai83jvl5dm.cloudfront.net": "d2av9jengy1nuo.cloudfront.net",
  "d2ta01t9frazet.cloudfront.net": "dffau4w2b5qi0.cloudfront.net",
  "d2o04x7e6owh5a.cloudfront.net": "d1em69zjdrrgxe.cloudfront.net",
  "do1fh9m3nieqw.cloudfront.net": "d39duzph8un49n.cloudfront.net",
  "d33hng2q86dqsh.cloudfront.net": "dhrfz1aysntuq.cloudfront.net",
  "d27hzybfabciej.cloudfront.net": "d1mzu6vluqxx1x.cloudfront.net",
  "d2v0bf3428fdct.cloudfront.net": "dvg00sai1tp1x.cloudfront.net",
  "dr1mjwww9pmvl.cloudfront.net": "dgwy2upw4qkq7.cloudfront.net",
  "d5q6qwu319cbo.cloudfront.net": "d4n6tk1hkqg1m.cloudfront.net",
  "d1tud5eh7mtkc6.cloudfront.net": "dz610fq0hrw82.cloudfront.net",
  "d3um9cbvojgv4z.cloudfront.net": "d3j312h51spf9h.cloudfront.net",
  "dfjatm0qfrwzr.cloudfront.net": "d28tdkkbzkt64z.cloudfront.net",
  "d1qn6pl548fbg3.cloudfront.net": "d3owkzi4egzokd.cloudfront.net",
  "d38zbp5pxtwtr6.cloudfront.net": "d3uurkcg6glx2s.cloudfront.net",
  "d1fd33ubnxyoa4.cloudfront.net": "dsgqpgdqklapp.cloudfront.net",
  "d2zj4cxmbz6jpl.cloudfront.net": "d1s9ziwzk74mr9.cloudfront.net",
  "dldg0xaf5brp0.cloudfront.net": "dk2ns05em422a.cloudfront.net",
  "d2kd4991ektzky.cloudfront.net": "d32py0a160ozbg.cloudfront.net",
  "d6q9e2exlp8zo.cloudfront.net": "d1wb6xh99u88zt.cloudfront.net",
  "d2xz8y9a1aoj3t.cloudfront.net": "d3i05f4khjnmn9.cloudfront.net",
  "d1271q199f3loy.cloudfront.net": "d1bukmbsmxngck.cloudfront.net",
  "d3v7ujh6rruzdy.cloudfront.net": "d1rwd53pytarzr.cloudfront.net",
  "d32gqfk47t7uww.cloudfront.net": "d8el6auev7deh.cloudfront.net",
  "d18em3szh11jgi.cloudfront.net": "d10909ix2rr3dk.cloudfront.net",
  "d1qlpj5dnidulp.cloudfront.net": "d24bo5ypzj4jex.cloudfront.net",
  "d2pr4iudvh6s2s.cloudfront.net": "d3olmh13pk6t66.cloudfront.net",
  "d1xfuppq3g677h.cloudfront.net": "d2ulwql12qvlc1.cloudfront.net",
  "d2dp344oxhgrfb.cloudfront.net": "djib0p3xblgbo.cloudfront.net",
  "d1h6f6ms9ossa8.cloudfront.net": "d32o2jqpd1lpt2.cloudfront.net",
  "d7cuw4k5t2lh2.cloudfront.net": "d398ad0flswv76.cloudfront.net",
  "d1zkvhdsxz09hf.cloudfront.net": "d1g4y3xi2ap2aw.cloudfront.net",
  "d27lbnq8mxd7ma.cloudfront.net": "dtsc0zgzgv09s.cloudfront.net",
  "dgme3hq1squ5.cloudfront.net": "d2lx9qr13lfh0u.cloudfront.net",
  "dn8gxm6aruv73.cloudfront.net": "d1jbez0yciah49.cloudfront.net",
  "d39fvw4qir10bv.cloudfront.net": "d3cjx9j8eiddq7.cloudfront.net",
  "d27zm19eay42nf.cloudfront.net": "d2j012pz92lo68.cloudfront.net",
  "d1y4a8b5ob2xap.cloudfront.net": "d2qsv3fw9hpc2q.cloudfront.net",
  "d35jsr3qkh7plm.cloudfront.net": "d2n0ldjw4oul4.cloudfront.net",
  "d2dzp74m0vppt8.cloudfront.net": "do7tbz7i6s0x.cloudfront.net",
  "d2zsj3xi49g01a.cloudfront.net": "d11v244sqeodyf.cloudfront.net",
  "d1k3u2iun2xrmd.cloudfront.net": "dkes41grtqsfj.cloudfront.net",
  "d3kpq7kjqwylkw.cloudfront.net": "dwy745sncr4p7.cloudfront.net",
  "d2sp3sbx947053.cloudfront.net": "d1b81ssnexd67q.cloudfront.net",
  "d1eykvun9tosnj.cloudfront.net": "d3lkrcvl3tznr2.cloudfront.net",
  "d3432l9l0st1fk.cloudfront.net": "d2irxvmuvbwcfd.cloudfront.net",
  "d1f4f559yd1efy.cloudfront.net": "dmpkpqkjb15if.cloudfront.net",
  "d1fjbqyb7pxqzs.cloudfront.net": "d36v0k52ntvqxq.cloudfront.net",
  "dr2rsajmi882a.cloudfront.net": "dh9wx6osflvjz.cloudfront.net",
  "d1f2gateahut55.cloudfront.net": "d3hw6wvtxkuvsn.cloudfront.net",
  "d14z5n6ynam7l4.cloudfront.net": "df3sgo51jd3nv.cloudfront.net",
  "d2pdx1fu8s8tns.cloudfront.net": "d2kfuejvesbc5d.cloudfront.net",
  "d2kh8g0i619t1c.cloudfront.net": "d15p2d83j6p4ck.cloudfront.net",
  "d1ld5crqwiulrn.cloudfront.net": "d1f97spzyrhp7m.cloudfront.net",
  "d1vog8avnexlpr.cloudfront.net": "dp0mgvka8y3fp.cloudfront.net",
  "dy9uff4hpflco.cloudfront.net": "d3qgh5e14t08pu.cloudfront.net",
  "d3giwzgk61puwq.cloudfront.net": "d36kikxy91hnk2.cloudfront.net",
  "dsd89k37g1flv.cloudfront.net": "dpdg3sjx4anjk.cloudfront.net",
  "dq8rrl7vcgmhv.cloudfront.net": "d3shcs0pc8c0dc.cloudfront.net",
  "d2bdwdhvrjhi4u.cloudfront.net": "d2eo9v5potou3d.cloudfront.net",
  "d3krdg47ac7mln.cloudfront.net": "d2sqmxxsvg3ftq.cloudfront.net",
  "d3f9b5pxu4bdcz.cloudfront.net": "d3volqxv13lf37.cloudfront.net",
  "d228enuyn2gjma.cloudfront.net": "dsucghsvseyv0.cloudfront.net",
  "d1y36f8l51e3dp.cloudfront.net": "d2d96064so3b7z.cloudfront.net",
  "dp4whqesgejw0.cloudfront.net": "d3g1bd8b8oab9i.cloudfront.net",
  "d213rcu3oj0yja.cloudfront.net": "d2b8p2rq45unbv.cloudfront.net",
  "d1q2aer0z1xcs.cloudfront.net": "d2g35k2aqehg44.cloudfront.net",
  "d3gqtklvc322vq.cloudfront.net": "d311sy9eg1naen.cloudfront.net",
  "d191bde51yn4t5.cloudfront.net": "d2v190xdarre30.cloudfront.net",
  "d1r4ib5kxa6b64.cloudfront.net": "d3a6ce5nd025ra.cloudfront.net",
  "dd6tfi4v48t01.cloudfront.net": "d3afwzaeqhrke8.cloudfront.net",
  "d3ngbr1xdvof1e.cloudfront.net": "d1khsjtbr87idm.cloudfront.net",
  "d2abynh8032uvm.cloudfront.net": "dk30s8vsk7aiz.cloudfront.net",
  "dkwz3kwxw8tjx.cloudfront.net": "d110yvsn73t3sp.cloudfront.net",
  "d2qo26fw801yin.cloudfront.net": "d2e0pviweiblsv.cloudfront.net",
  "d35tkw7o2cz572.cloudfront.net": "dwg7a1gcfr09w.cloudfront.net",
  "d3tukafackgg6x.cloudfront.net": "d2gegywaa9pnw5.cloudfront.net",
  "d3lxdqsp0ftnmz.cloudfront.net": "d2m0any3c59693.cloudfront.net",
  "d227hnwvkpslsi.cloudfront.net": "dqh9a7w53ehv8.cloudfront.net",
  "d31qfhuawscxbh.cloudfront.net": "d8pdpx38n8qfk.cloudfront.net",
  "d1ynthm7hptse2.cloudfront.net": "d5zhseqoobwkb.cloudfront.net",
  "d31l86cxeti1cx.cloudfront.net": "dput1liwr0qw3.cloudfront.net",
  "d354c57phymwy.cloudfront.net": "db7by5tft068q.cloudfront.net",
  "d1iulzxl7pixto.cloudfront.net": "d29yqpzg54am44.cloudfront.net",
  "d19mc57xsasd8c.cloudfront.net": "d31zs3n0qw867x.cloudfront.net",
  "dg79zohq32gx8.cloudfront.net": "d1djhikx1vcc97.cloudfront.net",
  "dyzis0jw4zxhl.cloudfront.net": "d14psurwcg603x.cloudfront.net",
  "d3lcfvkmbd5x3y.cloudfront.net": "d2sj7g8q3irr39.cloudfront.net",
  "d1dki0jxsv2196.cloudfront.net": "d3svqgcice1tey.cloudfront.net",
  "d1fhimktmfla3h.cloudfront.net": "d1aikk457l25mh.cloudfront.net",
  "dx5smcvsix6gr.cloudfront.net": "d2u2inscvajxte.cloudfront.net",
  "d3oj3j6wbnn868.cloudfront.net": "dz0rkdr7lz1hj.cloudfront.net",
  "d3m1sq3dodf0v9.cloudfront.net": "d32zz6w9bwlfrj.cloudfront.net",
  "d2hlie9gcs9h9h.cloudfront.net": "dut8n9zregtha.cloudfront.net",
  "d1pnn5ikjjwo90.cloudfront.net": "dxk13au8wwphz.cloudfront.net",
  "d2vkubx56lnoar.cloudfront.net": "d2m4eo2tldmlak.cloudfront.net",
  "d8pmcmz357qav.cloudfront.net": "d1okjpulttxz0w.cloudfront.net",
  "d1mpkxbnl6r3qt.cloudfront.net": "d2z2iytewq67h.cloudfront.net",
  "d39eymo04rpw7j.cloudfront.net": "d1uzdhx433ix9m.cloudfront.net",
  "d36ysr61ppbqua.cloudfront.net": "dmn8vsoyjpkwk.cloudfront.net",
  "d2mz84vpx5k2r9.cloudfront.net": "d3fvszjqcu1kfm.cloudfront.net",
  "dxunha1omb3qi.cloudfront.net": "d2ev8jq33v5j0l.cloudfront.net",
  "d2jlhxbc7540kd.cloudfront.net": "drgy9hgypqfah.cloudfront.net",
  "d2nsjw77beg93b.cloudfront.net": "d3k9clpstbhvjf.cloudfront.net",
  "d1txrn45pht921.cloudfront.net": "d1b033694kfwla.cloudfront.net",
  "dpsmzunvomf2q.cloudfront.net": "d1o7g3kraw0oeh.cloudfront.net",
  "d6ygvu145n3f0.cloudfront.net": "d1ex288kp61vg7.cloudfront.net",
  "d2ytwqgbc54ql7.cloudfront.net": "d2co6gkhd2wwey.cloudfront.net",
  "d3pxg995ungidb.cloudfront.net": "ddec31rza7fju.cloudfront.net",
  "d36emiexf11ief.cloudfront.net": "d2m1mw53q71wis.cloudfront.net",
  "d1er845czuflfj.cloudfront.net": "d3hggji7aaicbm.cloudfront.net",
  "d3rcpyymu11xl1.cloudfront.net": "d2s2jomqvwaaa.cloudfront.net",
  "di3ubul706wd9.cloudfront.net": "d24f1vlt9b93w4.cloudfront.net",
  "d3b4etj13giq7.cloudfront.net": "d3b4xbybwc9tyy.cloudfront.net",
  "d3hjr2nu87z2s8.cloudfront.net": "d2k119qlcgdxvf.cloudfront.net",
  "d1vbxywfrzfhcb.cloudfront.net": "dzc6ibgolskms.cloudfront.net",
  "dmmp5jem1fjx4.cloudfront.net": "d3vzkn8xrc4yji.cloudfront.net",
  "dk75jvo6s39mf.cloudfront.net": "d2dz7170rgmgt.cloudfront.net",
  "d1j92wn50untaz.cloudfront.net": "d33751o1hawo4z.cloudfront.net",
  "d1e4jbklikt869.cloudfront.net": "d1ehyq10ag3rr5.cloudfront.net",
  "d2sysh6hkjd92i.cloudfront.net": "d2zoq8kuxf42zf.cloudfront.net",
  "doxg6z2tot18y.cloudfront.net": "dz4eseespyt85.cloudfront.net",
  "dzt5uuckp6r6h.cloudfront.net": "d1898cfk2uecxy.cloudfront.net",
  "d2ek3evuikvgnn.cloudfront.net": "dq3zao0v1bv65.cloudfront.net",
  "d3bzupz9hf2u53.cloudfront.net": "d31pqn6pm1ra40.cloudfront.net",
  "d1hhi952ysmqpu.cloudfront.net": "d2o5pge6uc3oah.cloudfront.net",
  "d1s8bpia3c842k.cloudfront.net": "d8uh0v92q5rzn.cloudfront.net",
  "dtjssg9nz0ftu.cloudfront.net": "d10m2xpfrcuxex.cloudfront.net",
  "d3lxq1ze2vf4g.cloudfront.net": "d3k53atomd8uey.cloudfront.net",
  "d2h31ixjm9djoj.cloudfront.net": "danffx04nlwkb.cloudfront.net",
  "d2104poww0pm7n.cloudfront.net": "d3fbm8zzdpd9b6.cloudfront.net",
  "d1ujvs8v9a2t7m.cloudfront.net": "d2i57o83nuu4ad.cloudfront.net",
  "datit7wiudg7l.cloudfront.net": "dzqdga10mt97e.cloudfront.net",
};

export enum PPApiResponseType {
  ARRAY_BUFFER = "arraybuffer",
  BLOB = "blob",
  JSON = "json",
  TEXT = "text",
}

export enum PPApiTokenType {
  BEARER = "Bearer",
  BASIC = "Basic",
}

export enum PPApiTokenStorageType {
  LOCAL_STORAGE = "localstorage",
  COOKIE = "cookie",
}

export interface PPApiConfig {
  baseUrl: string;
  tokenKey?: string;
  tokenType?: PPApiTokenType;
  storedIn?: PPApiTokenStorageType;
  headers?: PPApiHeaders;
}

export interface PPApiOptions {
  apiPath: string;
  params?: PPApiParams;
  headers?: PPApiHeaders;
  responseType?: PPApiResponseType;
  withCredentials?: boolean;
  config?: PPApiConfig;
}

export class PPApiParams {}

export class PPApiHeaders {}

export interface PPApiMethodOptions {
  headers?: PPApiHeaders;
  observe?: "body" | "events" | "response";
  params?: PPApiParams;
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
}

export interface PPApiConfig {
  baseUrl: string;
  tokenKey?: string;
  tokenType?: PPApiTokenType;
  storedIn?: PPApiTokenStorageType;
  headers?: PPApiHeaders;
}

export interface PPApiOptions {
  apiPath: string;
  params?: PPApiParams;
  headers?: PPApiHeaders;
  responseType?: PPApiResponseType;
  withCredentials?: boolean;
  config?: PPApiConfig;
}

const hexToBase64 = (str: any) => {
  return btoa(
    String.fromCharCode.apply(
      null,
      str
        .replace(/\r|\n/g, "")
        .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
        .replace(/ +$/, "")
        .split(" ")
    )
  )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=*$/, "");
};
const keyCharAt = (key: string, i: number) => {
  return key.charCodeAt(Math.floor(i % key.length));
};
const b64_decode = (data: any) => {
  let o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    result = [];
  if (!data) {
    return data;
  }
  data += "";
  do {
    h1 = b64.indexOf(data.charAt(i++));
    h2 = b64.indexOf(data.charAt(i++));
    h3 = b64.indexOf(data.charAt(i++));
    h4 = b64.indexOf(data.charAt(i++));
    bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
    o1 = (bits >> 16) & 0xff;
    o2 = (bits >> 8) & 0xff;
    o3 = bits & 0xff;
    result.push(o1);
    if (h3 !== 64) {
      result.push(o2);
      if (h4 !== 64) {
        result.push(o3);
      }
    }
  } while (i < data.length);
  return result;
};
const decrypt = (key: string, data: string | number[]) => {
  data = b64_decode(data);
  return xor_decrypt(key, data);
};
const xor_encrypt = (key: any, data: any) => {
  return Object.assign([], data).map((c: string, i: any) => {
    return c.charCodeAt(0) ^ keyCharAt(key, i);
  });
};

const getAwsKey = (url: string) => {
  const path = "v3" + "/files/send-analytics-data";
  const options: PPApiOptions = {
    apiPath: path,
  };
  return Client.post(path, { url });
};
const encrypt = (key: any, data: any) => {
  data = xor_encrypt(key, data);
  return b64_encode(data);
};
const b64_encode = (data: any) => {
  let o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    r,
    i = 0,
    enc = "";
  if (!data) {
    return data;
  }
  do {
    o1 = data[i++];
    o2 = data[i++];
    o3 = data[i++];
    bits = (o1 << 16) | (o2 << 8) | o3;
    h1 = (bits >> 18) & 0x3f;
    h2 = (bits >> 12) & 0x3f;
    h3 = (bits >> 6) & 0x3f;
    h4 = bits & 0x3f;
    enc += b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);
  r = data.length % 3;
  return (r ? enc.slice(0, r - 3) : enc) + "===".slice(r || 3);
};
const xor_decrypt = (key: any, data: any) => {
  return Object.assign([], data)
    .map((c: number, i: any) => {
      return String.fromCharCode(c ^ keyCharAt(key, i));
    })
    .join("");
};
const base64ToHex = (str: string) => {
  str = str.replace(/\-/g, "+").replace(/\_/g, "/");
  for (
    var i = 0, bin = atob(str.replace(/[ \r\n]+$/, "")), hex = [];
    i < bin.length;
    ++i
  ) {
    let tmp = bin.charCodeAt(i).toString(16);
    if (tmp.length === 1) {
      tmp = "0" + tmp;
    }
    hex[hex.length] = tmp;
  }
  return hex.join("");
};
const GET_LICENCE = "v1" + `/videos/get-otp`;
const getKeyFromServer = async (params: any) => {
  return Client.get(GET_LICENCE, { params });
};

function setCharAt(str: string = "", index: number, chr: string = "") {
  if (index > str?.length - 1) {
    return str;
  }
  return str.substring(0, index) + chr + str.substring(index + 1);
}

async function getAwsCookieViaNetwork(data: any, array: Array<any>) {
  try {
    const res: any = await getAwsKey(data.videoUrl);

    if (res && res["data"]) {
      data["cookie"] = res["data"];
      data["createdAt"] = new Date();
      return data.cookie;
    }
  } catch (e) {
    console.log(e);
  } finally {
    array.push(data);
    // this.storageService.setAwsCookie(JSON.stringify(array));
  }
}

async function getAWSKey(videoUrl: string) {
  const storageAWSData = "";
  let cookieArray = [];
  if (storageAWSData.length > 0) {
    cookieArray = JSON.parse(storageAWSData);
  }
  const cookieData = {
    videoUrl: videoUrl,
    cookie: "",
  };
  return await getAwsCookieViaNetwork(cookieData, cookieArray);
}

const awsLogic = async (
  isLive: boolean,
  videoUrl: string,
  poster: string,
  isEnableFullScreen: boolean,
  videoDetails: any
) => {
  if (videoUrl.length === 0) {
    alert("No Video Found");
    return;
  }

  videoDetails.isLive = true;
  let epochEndTime = new Date(videoDetails.endTime).getTime() / 1000;
  const cookie = await getAWSKey(videoUrl);
  // const changedCookie = setCharAt(cookie, 0, '&');
  const changedCookie = cookieSplitter(cookie);
  const playerConfigLocal: any = {
    poster: poster,
    liveui: isLive,
    sources: [],
    autoplay: false,
    startTime: 0,
    fullScreenEnabled: isEnableFullScreen,
    fluid: false,
    fill: true,
    responsive: true,
    seekButtons: true,
    seekSeconds: 0,
    query: changedCookie.replace("?", ""),
  };

  if (!videoDetails.isLive && epochEndTime === 0) {
    alert("No Ent time found");
    // await this.location.back();
  }
  const browser = videojs.browser;

  if (
    browser["IS_IPAD"] ||
    browser["IS_IPHONE"] ||
    browser["IS_IOS"] ||
    browser["IS_SAFARI"]
  ) {
    const distribution = videoUrl.split("/");
    if (
      distribution.length >= 2 &&
      distributionChecked[distribution[2]] != undefined
    ) {
      distribution[2] = distributionChecked[distribution[2]];
    }
    videoUrl = distribution.join("/");
  }
  let query, epochStartTime;
  if (videoDetails.startTime && videoDetails.isLive) {
    epochStartTime = new Date(videoDetails.startTime).getTime() / 1000;
    query = `?start=${epochStartTime}${changedCookie}`;
  } else if (
    videoDetails.startTime &&
    videoDetails.endTime &&
    !videoDetails.isLive
  ) {
    epochStartTime = new Date(videoDetails.startTime).getTime() / 1000;
    epochEndTime = new Date(videoDetails.endTime).getTime() / 1000;
    query = `?start=${epochStartTime}${changedCookie}&end=${epochEndTime}`;
  } else {
    query = `?${changedCookie}`;
  }
  const data = {
    src: videoUrl + query,
    type: "application/x-mpegURL",
  };
  playerConfigLocal.sources = [];
  playerConfigLocal.sources.push(data);
  return playerConfigLocal;
};

async function penpencilLogic(
  isLive: boolean,
  videoUrl: string,
  poster: string,
  isEnableFullScreen: boolean,
  videoDetails: any
) {
  const browser = videojs.browser;
  // let HLStype = false;

  const isSafari =
    browser &&
    (browser["IS_SAFARI"] ||
      browser["IS_IOS"] ||
      browser["IS_IPAD"] ||
      browser["IS_IPHONE"] ||
      browser["IS_IPOD"]);
  const types = videoDetails?.videoDetails?.types ||
    videoDetails?.types || ["DASH"];
  console.log("IS SAFARI>", browser);
  let cookie = "";
  // if (types.length && types.includes('HLS')) {
  //   HLStype = true;
  // }
  const playerConfigLocal: any = {
    poster: poster,
    liveui: isLive,
    sources: [],
    autoplay: true,
    startTime: 0,
    fullScreenEnabled: isEnableFullScreen,
    fluid: true,
    fill: false,
    responsive: false,
    seekButtons: true,
    seekSeconds: 0,
  };
  let src;
  if (isSafari) {
    videoUrl = videoUrl.replace("d1d34p8vz63oiq", "d26g5bnklkwsh4");
    src = videoUrl.slice(0, -3) + "m3u8";
  } else {
    if (types.includes("HLS")) {
      cookie = await getAWSKey(videoUrl);
    }
    src = videoUrl.slice(0, -3) + "m3u8" + cookie;
  }
  if (isSafari) {
    const sources = [
      {
        src: src,
        // src: ,
        type: "application/x-mpegURL",
        withCredentials: false,
        cacheEncryptionKeys: true,
      },
    ];

    playerConfigLocal[
      "encryptionUri"
    ] = `${process.env.REACT_APP_PP_API_BACKEND}/v1/videos/get-hls-key?videoId=${videoDetails?.videoDetails?.id}`;

    playerConfigLocal["headers"] = [
      {
        authorization: `Bearer ${getAccessToken()}}`,
      },
    ];

    (playerConfigLocal["query"] = cookie.replace("?", "")),
      (playerConfigLocal.sources = sources);
    return playerConfigLocal;
  } else {
    playerConfigLocal["headers"] = [
      {
        authorization: `Bearer ${getAccessToken()}}`,
      },
    ];

    const sourceData = {
      src: videoUrl,
      type: "application/dash+xml",
      keySystems: {
        "org.w3.clearkey": {
          videoContentType: 'video/mp4;codecs="avc1.42c01e"',
          audioContentType: 'audio/mp4;codecs="mp4a.40.2"',
          getLicense: (emeOptions: any, keyMessage: any, callback: any) => {
            getLicenseFromServer(emeOptions, keyMessage, callback);
          },
        },
      },
    };

    let queryParam: string | undefined;
    let urlWithHeaders: string = videoUrl;

    try {
      const cookie = await getAWSKey(videoUrl);
      const changedCookie = cookieSplitter(cookie);

      if (changedCookie) {
        queryParam = `?${changedCookie}`;
        urlWithHeaders += queryParam;
      }

      if (queryParam) {
        try {
          playerConfigLocal.query = queryParam;
          if (sourceData && sourceData.src) {
            sourceData.src += queryParam;
          } else {
            throw new Error("sourceData or sourceData.src is not defined");
          }
        } catch (error) {
          console.error("Error configuring player:", error);
        }
      }
    } catch (error) {
      console.error("Error processing cookies:", error);
    }

    playerConfigLocal.sources = [];

    playerConfigLocal.sources.push(sourceData);
    return playerConfigLocal;
  }
}

const hexEncode = (code: string) => {
  let hex, i;

  let result = "";
  for (i = 0; i < code.length; i++) {
    hex = code.charCodeAt(i).toString(16);
    result += ("000" + hex).slice(-4);
  }

  return result;
};
const getLicenseFromServer = async (
  emeOptions: any,
  keyMessage: any,
  callback: any
) => {
  const request = JSON.parse(new TextDecoder().decode(keyMessage));
  const params = {
    key: hexEncode(encrypt(getAccessToken(), base64ToHex(request.kids[0]))),
    isEncoded: true,
  };
  try {
    const response: any = await getKeyFromServer(params);
    console.log(response);
    console.log("response");
    const keyObj = {
      kty: "oct",
      kid: request.kids[0],
      k: hexToBase64(decrypt(getAccessToken(), response["data"].otp)), // This key should be come from server
    };

    callback(
      null,
      new TextEncoder().encode(
        JSON.stringify({
          keys: [keyObj],
        })
      )
    );
  } catch (e) {
    console.log("errorerror");
    console.log(e);
  }
};

function PenPencilVideo({
  children,
  src,
  videoDetails,
  onPlayerInit,
  onPlayerDispose,
  defaultPaused,
  defaultMuted,
}: any) {
  const containerRef = useRef(null as any);

  const [playerOptions, setPlayerOptions] = useState(null as any);
  const [localPlayerOptions, setLocalPlayerOptions] = useState(null as any);

  const qualities = ["720p", "480p", "360p", "240p", "Auto"];
  const qualitiesMapping = [720, 480, 360, 240, "Auto"];
  // WIP
  // const playerConfigReceived = penpencilLogic(false, src, '', true, videoDetails).then((response) => response.json())
  // .then((data) => {
  // console.log('RECEIVED DATA',data , playerConfigReceived)})
  // const playerOptions = {
  //     title: ' ',
  //     qualities: qualities.map((quality, index) => {
  //         return {
  //             title: ' ',
  //             sources: [{
  //                 ...penpencilLogic(false, src, '', true, videoDetails),
  //                 title: ' ',
  //                 label: quality,
  //                 default: index === 1,
  //                 value: qualitiesMapping[index],
  //
  //             }],
  //             label: quality,
  //             default: index === 1,
  //         }
  //     })
  // };

  async function addPlayerOptions() {
    const d = await penpencilLogic(false, src, "", true, videoDetails);
    const _playerOptions = {
      title: " ",
      qualities: qualities.map((quality, index) => {
        return {
          title: " ",
          sources: [
            {
              title: " ",
              label: quality,
              default: index === 1,
              value: qualitiesMapping[index],
              ...d?.sources?.[0],
            },
          ],
          label: quality,
          default: index === 1,
        };
      }),
    };
    setLocalPlayerOptions(d);
    setPlayerOptions(_playerOptions);
  }

  useEffect(() => {
    addPlayerOptions();
  }, [videoDetails]);

  useEffect(() => {
    try {
      if (containerRef.current && playerOptions) {
        const videoEl = containerRef.current.querySelector("video");

        const player: any = videojs(videoEl, {
          ...defaultPlayerOptions,
          ...playerOptions,
          html5: {
            vhs: {
              hlsjsConfig: {
                startLevel: 0,
                capLevelToPlayerSize: false,
                // startQuality: 106,
                // blacklistDuration: 120,
                enableWorker: true,
                liveBackBufferLength: 15,
                backBufferLength: 15,
                liveMaxBackBufferLength: 15,
                maxBufferSize: 0,
                maxBufferLength: 10,
                liveSyncDurationCount: 1,
              },
            },
          },
          plugins: {
            eme: {},
            hotkeys: {
              volumeStep: 0.2,
              seekStep: 10,
              enableModifiersForNumbers: false,
            },
          },
          preload: "metadata",
          noUITitleAttributes: true,
          userActions: {
            hotkeys: function (event) {
              let keyCode = event.code.toLowerCase();
              console.log("KEY code>>", keyCode, player.paused());
              switch (keyCode) {
                case "arrowleft":
                  var div = document.getElementById("actions-animation");
                  if (div) {
                    div.className =
                      "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                    div.innerHTML = `
                        <div class="flex flex-row items-center justify-center col-span-1 text-center ">
                            <img src="backward.gif" id="backward-img"/>
                          </div>
                        `;
                    setTimeout(() => {
                      if (div) {
                        div.innerHTML = "";
                        div.classList.remove("z-[1000]");
                      }
                    }, 600);
                  }
                  break;
                case "arrowright":
                  var div = document.getElementById("actions-animation");
                  if (div) {
                    div.className =
                      "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                    div.innerHTML = `<div class="col-span-2"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center ">
        <img src="forward.gif" id="forward-img" />
      </div>
    `;
                    // document.appendChild(div);
                    setTimeout(() => {
                      if (div) {
                        div.innerHTML = "";
                        div.classList.remove("z-[1000]");
                      }
                    }, 600);
                  }
                  break;
                case "space":
                  var div = document.getElementById("actions-animation");
                  if (div) {
                    div.className =
                      "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                    div.innerHTML = `<div class="col-span-1"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center">
     <div class="play-pause-img-div flex flex-row items-center justify-center opacity-80">
        <img src=${
          player.paused() ? "play.svg" : "pause.svg"
        } id="play-pause-img" class="seek-img" />
      </div>
      </div>
    `;
                    setTimeout(() => {
                      if (div) {
                        div.innerHTML = "";
                        div.classList.remove("z-[1000]");
                      }
                    }, 300);
                  }
              }
            },
          },
        });

        player.on("loadstart", (e: any) => {
          const vhs = player.tech().hls;

          if (vhs) {
            vhs.xhr.beforeRequest = (options: any) => {
              let URI = options.uri || "";
              console.log(
                "PLAYER OPTION HEADERS>>>>>",
                localPlayerOptions.headers,
                URI
              );
              if (
                URI.includes("v1/videos/get-hls-key") &&
                localPlayerOptions?.headers &&
                Object.keys(localPlayerOptions.headers).length > 0
              ) {
                console.log(
                  "PLAYER OPTION HEADERS>>",
                  URI,
                  Object.keys(localPlayerOptions.headers)
                );
                const headers = localPlayerOptions.headers;
                console.log("HEADERS>>>", headers);
                options.headers = headers;
              }
              try {
                if (localPlayerOptions?.query) {
                  if (localPlayerOptions.query[0] !== "?") {
                    localPlayerOptions.query = "?" + localPlayerOptions.query;
                  }

                  URI += localPlayerOptions.query;
                  options.uri = URI;
                }
              } catch (error) {
                console.error("Error in beforeRequest:", error);
              }
            };
          }
        });
        player.eme();
        // used to move children component into player's element
        // your may not the script
        const playerEl = player.el();

        player.on("qualitychange", (event: any, selected: any) => {});

        player.on("pause", (e: any) => {
          var div = document.getElementById("actions-animation");
          if (div) {
            div.className =
              "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
            div.innerHTML = `<div class="col-span-1"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center">
     <div class="play-pause-img-div flex flex-row items-center justify-center opacity-80">
        <img src=${
          player.paused() ? "play.svg" : "pause.svg"
        } id="play-pause-img" class="seek-img" />
      </div>
      </div>
    `;
            setTimeout(() => {
              if (div) {
                div.innerHTML = "";
                div.classList.remove("z-[1000]");
              }
            }, 300);
          }
          console.log("Pause", e);
        });
        player.on("play", (e: any) => {
          var div = document.getElementById("actions-animation");
          if (div) {
            div.className =
              "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
            div.innerHTML = `<div class="col-span-1"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center">
     <div class="play-pause-img-div flex flex-row items-center justify-center opacity-80">
        <img src=${
          player.paused() ? "play.svg" : "pause.svg"
        } id="play-pause-img" class="seek-img" />
      </div>
      </div>
    `;
            setTimeout(() => {
              if (div) {
                div.innerHTML = "";
                div.classList.remove("z-[1000]");
              }
            }, 300);
          }
          console.log("Play", e);
        });
        const flag = player.getChild("PlayToggleLayer").el();
        for (const child of containerRef.current.children) {
          if (child !== playerEl) {
            playerEl.insertBefore(child, flag);
          }
        }

        onPlayerInit && onPlayerInit(player);

        // @ts-ignore
        window.player = player;
        player.currentTime(
          JSON.parse(localStorage.getItem("player_start_time") || "0")
        );
        player.play();
        return () => {
          onPlayerDispose && onPlayerDispose(null);
          player.dispose();
        };
      }
    } catch (e) {}
  }, [onPlayerInit, onPlayerDispose, playerOptions]);
  if (!playerOptions) {
    return <></>;
  }
  return (
    <div className="player" ref={containerRef}>
      <video />
      {children}
    </div>
  );
}

export default PenPencilVideo;
